import React from 'react';
import { Modal, makeStyles, Theme, createStyles, Backdrop, Fade } from '@material-ui/core';
import { QuestForm } from './QuestForm';
import { Quest, QuestType } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
      outline: 'none',
    },
  })
);

type Props = {
  open: boolean;
  seasonId: string;
  quest?: Quest | null;
  questType: QuestType;
  onClose: () => void;
};

export const QuestModal = ({ open, seasonId, quest, questType, onClose }: Props) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.form}>
          <QuestForm seasonId={seasonId} quest={quest} questType={questType} onClose={onClose} />
        </div>
      </Fade>
    </Modal>
  );
};
